import React from 'react';
import pimcoreClient from '../../../apollo/pimcoreClient';
import pimcoreClientCached from '../../../apollo/pimcoreClientCachedRequests';
import { ResourceLibraryArticleItemsProvider } from '../contexts/ResourceLibraryArticleItemsProvider';
import { ResourceLibraryNewsItemsProvider } from './ResourceLibraryNewsItemsProvider';
import { ResourceLibraryNewProductIntroductionItemsProvider } from './ResourceLibraryNewProductIntroductionItemsProvider';
import { ResourceLibraryItemsProvider } from './ResourceLibraryItemsProvider';
import { ResourceTypesProvider } from './ResourceTypesProvider';
import { BrandsProvider } from './BrandsProvider';
import { ProductGroupsProvider } from './ProductGroupsProvider';
import { ProductApplicationsProvider } from './ProductApplicationsProvider';
import { ResourceLibrarySitePageItemsProvider } from './ResourceLibrarySitePageItemsProvider';

interface ResourceLibraryProvidersProps {
    children: React.ReactNode;
}

export const ResourceLibraryProviders = ({ children }: ResourceLibraryProvidersProps) => {
    return (
        <BrandsProvider apolloClient={pimcoreClient}>
            <ResourceTypesProvider apolloClient={pimcoreClient}>
                <ProductGroupsProvider apolloClient={pimcoreClient}>
                    <ProductApplicationsProvider apolloClient={pimcoreClient}>
                        <ResourceLibraryArticleItemsProvider apolloClient={pimcoreClientCached}>
                            <ResourceLibraryNewsItemsProvider apolloClient={pimcoreClientCached}>
                                <ResourceLibraryNewProductIntroductionItemsProvider
                                    apolloClient={pimcoreClientCached}
                                >
                                    <ResourceLibrarySitePageItemsProvider
                                        apolloClient={pimcoreClientCached}
                                    >
                                        <ResourceLibraryItemsProvider
                                            apolloClient={pimcoreClientCached}
                                        >
                                            {children}
                                        </ResourceLibraryItemsProvider>
                                    </ResourceLibrarySitePageItemsProvider>
                                </ResourceLibraryNewProductIntroductionItemsProvider>
                            </ResourceLibraryNewsItemsProvider>
                        </ResourceLibraryArticleItemsProvider>
                    </ProductApplicationsProvider>
                </ProductGroupsProvider>
            </ResourceTypesProvider>
        </BrandsProvider>
    );
};
